// パネル(type / id)と加工指示セクションID の相互変換を提供する。
//
// kakousiji/ 配下の service は sectionId("fukushizai" / "nouhinyotei" など)を基準に組まれているが、
// 品番マスタ側は panelType("113" / "131" など)を基準に扱っている。
// sectionCatalog は id と panelType を対で持つため、この対応表を1か所に用意すれば
// ロジック本体を分岐させずに両画面から同じ service を呼べる。
import { kakousijiSectionCatalog, kakousijiSampleSectionCatalog } from "../sectionCatalog";
import { canonicalPanelType as defaultCanonicalPanelType } from "../sectionResolver";

export function createSectionIdBridge(deps = {}) {
    const canonical = typeof deps.canonicalPanelType === "function"
        ? deps.canonicalPanelType
        : defaultCanonicalPanelType;
    const catalogs = Array.isArray(deps.catalogs) && deps.catalogs.length !== 0
        ? deps.catalogs
        : [kakousijiSectionCatalog, kakousijiSampleSectionCatalog];

    const sectionIdByType = new Map();
    const typeBySectionId = new Map();
    const sectionByType = new Map();

    catalogs.forEach((catalog) => {
        (Array.isArray(catalog) ? catalog : []).forEach((section) => {
            const sectionId = String(section?.id ?? "").trim();
            const panelType = canonical(section?.panelType);
            if (sectionId === "" || panelType === "") return;
            // 同一 panelType に複数セクションがぶら下がる場合は catalog の先頭を優先する。
            if (!sectionIdByType.has(panelType)) sectionIdByType.set(panelType, sectionId);
            if (!sectionByType.has(panelType)) sectionByType.set(panelType, section);
            if (!typeBySectionId.has(sectionId)) typeBySectionId.set(sectionId, panelType);
        });
    });

    // panelType(20/130/jutyusu などの別名も可) から sectionId を引く。
    function sectionIdByPanelType(panelType) {
        return sectionIdByType.get(canonical(panelType)) ?? "";
    }

    // sectionId から正規化済みの panelType を引く。
    function panelTypeBySectionId(sectionId) {
        return typeBySectionId.get(String(sectionId ?? "").trim()) ?? "";
    }

    // panelInfo から sectionId を引く。type で引けない場合は id で補う。
    function sectionIdByPanelInfo(panelInfo) {
        if (panelInfo === null || panelInfo === undefined) return "";
        const byType = sectionIdByPanelType(panelInfo.type);
        if (byType !== "") return byType;
        return sectionIdByPanelType(panelInfo.id);
    }

    // panelType に対応する catalog 定義そのものを返す。
    function sectionByPanelType(panelType) {
        return sectionByType.get(canonical(panelType)) ?? null;
    }

    return {
        sectionIdByPanelType,
        panelTypeBySectionId,
        sectionIdByPanelInfo,
        sectionByPanelType
    };
}
